import Layout from "../components/layout/Layout";
import AIAutoSetupPage from "../components/page/AIAutoSetupPage";

const AIAutoSetupLayout = () => {
    return (
        <Layout>
            <AIAutoSetupPage />
        </Layout>
    );
}
export default AIAutoSetupLayout;
